
import React, { useEffect, useState } from 'react'; 
import { useTranslation } from 'react-i18next';
import { useCookies } from 'react-cookie';
import { retrieveStockSession } from '../../Services/StockSessionApiService';
import RealTimeQuotation from '../../Components/PrimeReact/MarketSummary/realTimeQuotation';
import LogoHeader from '../../Components/PrimeReact/logoBanner';
import { useAuthHeader } from "../../auth/AuthService";


function MarketSummary() {
    const authHeader = useAuthHeader();
    const {t, i18n} = useTranslation();
    const [cookies, setCookie] = useCookies(['bType']);
    const [STATE, setSTATE] = useState(0);
    const MARKET_CLOSED = 99;

    async function checkStockSession() {
        await retrieveStockSession(authHeader())
        .then((response) => {
            let check = response.data.data.session;
            if (check) {
                setSTATE(MARKET_CLOSED);
            }
        })
        .catch((error) => console.log(error))
    }

    useEffect(() => {
        checkStockSession();
        const intervalStockSession = setInterval(checkStockSession, 5000);
        if (STATE == 99 || (new Date().setHours(15,10,0)) < (new Date().getTime())) {
            clearInterval(intervalStockSession)
        }
        return () => {
            clearInterval(intervalStockSession)
        }
    }, [i18n.language, STATE]);


  return (
    <>
      <LogoHeader />
      <RealTimeQuotation STATE={STATE}/>
    </>
  );
}

export default MarketSummary;
